<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="margin-top: 150px;"><em>My perilous journey begins long ago,</em></p>
<p style="text-indent: 0em"> <em>A soul awakened, an unseen spark,</em></p>
<p style="text-indent: 0em"><em>To venture forth, to discover, to know,</em></p>
<p style="text-indent: 0em"><em>A passage through the dark.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?458afe58